// extracted by mini-css-extract-plugin
export var headerUp = "styles-module--header-up--kZhuR";
export var image = "styles-module--image--uHdaj";
export var mainHeader = "styles-module--main-header--xmD9m";
export var mainNav = "styles-module--main-nav--4DPiw";
export var mobileHamburgerElectronic = "styles-module--mobile-hamburger-electronic--Kdxi0";
export var navLogo = "styles-module--nav-logo--eYJHP";